import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { default as CTAComponent } from "../cta/cta";
import QuickFacts from "../quick-fact/quick-fact";
import { GatsbyImage } from "gatsby-plugin-image";

type HeroLandingProps = {
  showRfqCta: boolean;
};

type HeroThemeProps = {
  theme?: string | null | undefined;
};

type HeroImageProps = {
  imageFitContain: boolean;
};

export const HeroBackground = styled.div`
  box-sizing: border-box;
  max-width: calc(${theme.maxWidth} + ${theme.spacing[32]});
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  transition: min-height 0.5s ease-in-out;
  background: ${theme.gradient.lightBlue};

  ${theme.largerThan.md} {
    min-height: 300px;
    margin-bottom: ${theme.spacing[16]};
  }

  ${theme.largerThan.xl} {
    border-radius: ${theme.borderRadius};
  }
`;

export const HeroImageRight = styled.div<HeroThemeProps>`
  box-sizing: border-box;
  // max-width: calc(${theme.maxWidth} + ${theme.spacing[64]});
  margin: 0 auto ${theme.spacing[8]};
  padding: ${theme.spacing[8]} 0;
  position: relative;
  overflow: hidden;
  transition: min-height 0.5s ease-in-out;

  ${(props) =>
    props.theme === "light-blue" &&
    `
    // padding-top: ${theme.spacing[8]};
    background: ${theme.gradient.lightBlue};
  `};

  ${theme.largerThan.md} {
    min-height: 300px;
    padding: ${theme.spacing[16]} 0;
  }

  ${theme.largerThan["2xl"]} {
    padding: ${theme.spacing[18]};
  }

  > .container {
    display: grid;
    gap: ${theme.spacing[16]};
  }

  .trustpilot-certs {
    display: grid;
    gap: ${theme.spacing[4]};

    ${theme.largerThan.xl} {
      align-content: flex-end;
      justify-content: flex-end;
    }
  }
`;

export const HeroImageRightText = styled.div`
  order: 2;

  ${theme.largerThan.md} {
    order: 1;
    padding-right: ${theme.spacing[8]};
  }
`;

export const HeroImageRightImage = styled(GatsbyImage)<HeroImageProps>`
  border-radius: ${theme.borderRadius};
  order: 1;

  ${theme.largerThan.md} {
    aspect-ratio: 1 / 1;
    order: 2;
  }

  ${(props) =>
    props.imageFitContain && `img { object-fit: contain !important; }`}
`;

export const HeroImageRightAnimation = styled.div`
  border-radius: ${theme.borderRadius};
  order: 1;
  position: relative;

  ${theme.smallerThan.md} {
    display: none;
  }

  ${theme.largerThan.md} {
    order: 2;
    grid-column: span 3 / span 3;
  }

  ${theme.largerThan.lg} {
    grid-column: span 4 / span 4;
  }

  > div {
    position: absolute;
    height: auto !important;
  }
`;

export const HeroBackgroundFull = styled(GatsbyImage)`
  height: 100px;
  transition: min-height 0.5s ease-in-out;
  background-color: ${theme.colors.white};

  ${theme.largerThan.md} {
    position: absolute !important;
    top: 0;
    left: auto;
    right: 0;
    bottom: 0;
    width: 100%;
    height: auto;
  }
`;

export const HeroBackgroundDesktop = styled(GatsbyImage)`
  ${theme.smallerThan.md} {
    display: none !important;
  }

  ${theme.largerThan.md} {
    display: block;
    position: absolute !important;
    top: 50%;
    transform: translateY(-50%);
    height: 100%;
    left: auto;
    right: 0;
  }
`;

export const HeroContentWrapper = styled.div<HeroLandingProps>`
  position: relative;
  z-index: 1;
  padding: ${theme.spacing[8]} 0;

  ${theme.largerThan.md} {
    padding: ${theme.spacing[16]} 0;
  }
`;

export const HeroText = styled.div`
  display: grid;
  gap: ${theme.spacing[8]};
`;

export const HeroHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: ${theme.spacing[4]};
  max-width: 650px;
`;

export const HeroAction = styled.div`
  max-width: 450px;
  margin: 0 auto;
`;

export const HeroTitle = styled.h1`
  margin: 0;
`;

export const HeroSubtitle = styled.div``;

export const CTACaption = styled.div`
  margin-top: ${theme.spacing[4]};
  color: ${theme.colors.darkBlues[50]};
  font-size: ${theme.fontSizes[0]};
`;

export const CTAButton = styled(CTAComponent)<{}>`
  padding: ${theme.spacing[4]} ${theme.spacing[8]} !important;

  ${theme.largerThan.lg} {
    font-size: ${theme.fontSizes[4]};
    transition: all 0.1s ease-out;

    &:hover {
      transform: scale(1.02);
    }
  }
`;

export const CTA = styled.div``;

export const StyledQuickFacts = styled(QuickFacts)`
  max-width: 500px;
`;

export const Certifications = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[4]};
  margin: 0;
  padding: 0;
  ${theme.text.xs};

  ${theme.largerThan.lg} {
    flex-direction: row;
    align-items: center;
  }

  li {
    display: flex;
    gap: 0.75rem;
    color: ${theme.colors.darkBlues[75]};
    align-items: center;

    ${theme.largerThan.lg} {
      align-items: center;
    }
  }
`;
